module.exports = __webpack_public_path__ + "website/img/core6_3.ae9be8b4.png";